import { render, staticRenderFns } from "./CommunityTopic.vue?vue&type=template&id=0de2fe22"
import script from "./CommunityTopic.vue?vue&type=script&lang=js"
export * from "./CommunityTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports